export default class Serializer {

    static clamp(value: number) {
        return Math.max(0, Math.min(255, value));
    }

    static clampArray(values: number[]) {
        return values.map(v => this.clamp(v));
    }

    protected _buffer: number[] = [];

    get buffer() {return this._buffer;}

    constructor(bytes?: number[]) {
        if (bytes != undefined) this._buffer = Serializer.clampArray(bytes);
    }

    toBuffer() {
        return new Uint8Array(this._buffer);
    }

    writeBytes(...bytes: number[]) {
        this._buffer = this._buffer.concat(Serializer.clampArray(bytes));
    }

    readBytes(length: number) {
        return this._buffer.splice(0, length);
    }

    //numbers
    writeUInt32(n: number) {
        const buffer = new Uint8Array(4);
        const view = new DataView(buffer.buffer);
        view.setUint32(0, n);
        const arr = Array.from(buffer);

        this.writeBytes(...arr);
    }

    readUInt32() {
        const buffer = new Uint8Array(this.readBytes(4));
        const view = new DataView(buffer.buffer);

        return view.getUint32(0);
    }

    writeInt32(n: number) {
        const buffer = new Uint8Array(4);
        const view = new DataView(buffer.buffer);
        view.setInt32(0, n);
        const arr = Array.from(buffer);

        this.writeBytes(...arr);
    }

    readInt32() {
        const buffer = new Uint8Array(this.readBytes(4));
        const view = new DataView(buffer.buffer);

        return view.getInt32(0);
    }

    writeFloat32(n: number) {
        const buffer = new Uint8Array(4);
        const view = new DataView(buffer.buffer);
        view.setFloat32(0, n);
        this.writeBytes(...Array.from(buffer));
    }

    readFloat32() {
        const buffer = new Uint8Array(this.readBytes(4));
        const view = new DataView(buffer.buffer);

        return view.getFloat32(0);
    }

    

    //string
    writeString(text: string) {
        this.writeUInt32(text.length);
        this.writeBytes(...text.split("").map(char => char.charCodeAt(0)))
    }

    readString() {
        const len = this.readUInt32();
        const textBytes = this.readBytes(len);

        return textBytes.map(byte => String.fromCharCode(byte)).join("");
    }

    //bool
    writeBool(bool: boolean) {
        this.writeBytes(bool ? 1 : 0);
    }

    readBool() {
        const byte = this.readBytes(1)[0];

        return byte === 1 ? true : false;
    }

}